import React from 'react'
import {
  NumberInput, ReferenceInput, SelectInput, Filter,
} from 'react-admin'

const AdjustmentListFilter = props => (
  <Filter {...props}>
    <ReferenceInput
      label="User"
      source="user_id"
      reference="user"
      allowEmpty={false}
      sort={{ field: 'email', order: 'ASC' }}
      perPage={10000}
    >
      <SelectInput optionText="email" />
    </ReferenceInput>
    <ReferenceInput
      label="Owner"
      source="account_id"
      reference="account"
      allowEmpty={false}
      sort={{ field: 'name', order: 'ASC' }}
      perPage={10000}
    >
      <SelectInput optionText="name" />
    </ReferenceInput>
    <NumberInput source="points" step={1} />
    <SelectInput
      label="Type"
      source="type"
      allowEmpty={false}
      choices={[
        { id: 'DEBIT', name: 'DEBIT' },
        { id: 'CREDIT', name: 'CREDIT' },
      ]}
    />
    <SelectInput
      label="Status"
      source="status"
      allowEmpty={false}
      choices={[
        { id: 'PENDING', name: 'PENDING' },
        { id: 'REJECTED', name: 'REJECTED' },
        { id: 'COMPLETED', name: 'COMPLETED' },
      ]}
    />
  </Filter>
)

export default AdjustmentListFilter
